<template>
  <div
    v-if="this.$route.name == 'DesignGroupUpdate'"
    class="content d-flex flex-column flex-column-fluid"
    id="kt_content"
  >
    <div class="post d-flex flex-column-fluid" id="kt_post">
      <div v-if="!loading" id="kt_content_container" class="container-xxl">
        <form
          id="kt_ecommerce_add_category_form"
          class="form d-flex flex-column flex-lg-row"
          data-kt-redirect="../../demo1/dist/apps/ecommerce/catalog/categories.html"
        >
          <div class="d-flex flex-column flex-row-fluid gap-7 gap-lg-10">
            <div class="card card-flush py-4">
              <div class="card-header">
                <div v-for="(errorArray, index) in errors" :key="index">
                  <span class="text-danger">{{ errorArray[0] }} </span>
                </div>
                <br />
              </div>

              <div class="card-body pt-0">
                <div class="mb-10 fv-row">
                  <input
                    type="text"
                    name="category_name"
                    v-model="form.name"
                    class="form-control mb-2"
                    :placeholder="'الاسم'"
                  />
                </div>

                <div class="mb-10 fv-column">
                  <div class="d-flex flex-row gap-20">
                    <!-- First checkbox list -->
                    <div class="d-flex flex-column gap-3 flex-1">
                      انواع المقاسات
                      <div
                        v-for="size in sizes"
                        :key="size.id"
                        class="form-check"
                      >
                        <input
                          class="form-check-input"
                          type="checkbox"
                          :value="size.id"
                          :id="'size-' + size.id"
                          v-model="form.size_type_id"
                        />
                        <label
                          class="form-check-label"
                          :for="'size-' + size.id"
                        >
                          {{ size.name }}
                        </label>
                      </div>
                    </div>

                    <!-- Second checkbox list -->
                    <div class="d-flex flex-column gap-3 flex-1 mr-10">
                      انواع الاقمشة
                      <div
                        v-for="fabric in fabrics"
                        :key="fabric.id"
                        class="form-check"
                      >
                        <input
                          class="form-check-input"
                          type="checkbox"
                          :value="fabric.id"
                          :id="'fabric-' + fabric.id"
                          v-model="form.fabric_id"
                        />
                        <label
                          class="form-check-label"
                          :for="'fabric-' + fabric.id"
                        >
                          {{ fabric.name }}
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="w-100 w-md-200px">
              <input type="file" ref="image" />
            </div>
            <div class="d-flex justify-content-end">
              <router-link
                :to="{ name: 'DesignGroup' }"
                class="btn btn-light me-5"
              >
                رجوع
              </router-link>
              <button
                type="submit"
                @click.prevent="update"
                id="kt_ecommerce_add_category_submit"
                class="btn btn-primary"
              >
                <span class="indicator-label">حفظ</span>
                <span class="indicator-progress"
                  >Please wait...
                  <span
                    class="spinner-border spinner-border-sm align-middle ms-2"
                  ></span
                ></span>
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  setup() {},
  computed: {},
  data() {
    return {
      id: this.$route.params.id,

      languages: this.$dashboardData.allLanguages,
      showLang: this.$dashboardData.languageUniversal,
      form: {
        id: this.$route.params.id,
        size_type_id: [],
        fabric_id: [],
      },
      loading: 1,
      errors: [],
      sizes: [],
      fabrics: [],
    };
  },

  mounted() {
    if (!this.id) {
      this.$router.push({ name: "DesignGroup" });
    } else {
      this.edit();
      this.getSizes();
      this.getFabrics();
      this.getCategorySizeTypes();
    }
  },
  methods: {
    changeLang(lang) {
      this.showLang = lang;
    },
    edit() {
      this.$axios
        .post("admin/category/fetch?id=" + this.id)
        .then((response) => {
          this.form = response.data.data;
          this.loading = 0;
        });

      this.$axios
        .post("admin/category-fabric?category_id=" + this.id)
        .then((response) => {
          console.log("admin/category-fabric =", response.data.data);
          this.form.fabric_id = Array.isArray(response.data.data)
            ? response.data.data
            : [];
          this.loading = 0;
        })
        .catch((error) => {
          console.error("Error fetching size types:", error);
          this.form.fabric_id = []; // Fallback to empty array on error
          this.loading = 0;
        });
    },
    update() {
      this.form.image = this.$refs.image.files[0];
      this.form.type = "other";
      const formData = this.$serialize(this.form, this.$serializeOptios);
      this.$axios.post("admin/category/edit", formData).then((response) => {
        if (response.data.code == 201) {
          this.errors = response.data.data;
        }
        if (response.data.code == 200) {
          this.$toast.success(response.data.messages);
          this.errors = [];
          this.$router.push({ name: "DesignGroup" });
        } else {
          // this.$toast.error(response.data.message);
        }
      });
    },
    getSizes() {
      this.$axios.get("admin/all-size-type").then((response) => {
        this.sizes = response.data.data;
      });
    },
    getFabrics() {
      this.$axios.get("admin/fabric/all").then((response) => {
        console.log("this.fabrics =", response.data.data);
        this.fabrics = response.data.data;
      });
    },
    getCategorySizeTypes() {
      this.$axios
        .post("admin/size-type-category/fetch?category_id=" + this.id)
        .then((response) => {
          console.log("sizetypecateg response =", response.data);
          // Ensure we always set an array, even if response is empty
          this.form.size_type_id = Array.isArray(response.data.data)
            ? response.data.data
            : [];
          this.loading = 0;
        })
        .catch((error) => {
          console.error("Error fetching size types:", error);
          this.form.size_type_id = []; // Fallback to empty array on error
          this.loading = 0;
        });
    },
  },
  watch: {
    $route() {
      this.form = {
        fabric_id: [],
      };
    },
  },
};
</script>

<style scoped></style>
